import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withRouter } from "react-router-dom";
import {
  GetProvinces,
  GetCityByProvinceId,
  GetAllUserTypes,
  AddUser,
  GetUser,
  EditUser,
  HasTell,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

var firstProvinceId = "";

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nationCode: "0",
      flag: false,
      province: [],
      provinceId: null,
      name: "",
      nameHelper: "",
      family: "",
      familyHelper: "",
      tell: "",
      tellHelper: "",
      address: "",
      addressHelper: "",
      email: "",
      businessCode: "",
      cityId: null,
      userTypeId: "",
      permission: false,
      agent: false,
      cities: [],
      userTypes: [],
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      introducerCode: "",
      passWord: "",
      passwordHelper: "",
      oldTell: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    if (this.props.match.params.userId) {
      GetUser(this.props.match.params.userId)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else this.setState({ oldTell: responseJson.tell });
          this.setState({
            name: responseJson.name,
            family: responseJson.family,
            tell: responseJson.tell,
            passWord: responseJson.passWord,
            address: responseJson.address,
            email: responseJson.email,
            businessCode: responseJson.businessCode,
            provinceId: responseJson.objCity.provinceId
              ? responseJson.objCity.provinceId
              : "",
            cityId: responseJson.cityId,
            userTypeId: responseJson.userTypeId,
            permission: responseJson.permission,
            agent: responseJson.agent,
            nationCode: responseJson.nationCode,
            // introducerCode: responseJson.introducerCode,
          });

          firstProvinceId = responseJson.objCity.provinceId;
          this.getCitiesByProvince();
        })
        .catch((error) => {
          toast.error(error.message);
          console.error(error);
        });
    }

    GetProvinces(0, 999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });

    GetAllUserTypes()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ userTypes: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  getCitiesByProvince = () => {
    if(this.state.provinceId != null){
      firstProvinceId = this.state.provinceId;
    }
      GetCityByProvinceId(firstProvinceId) //firstProvinceId :  (چون آی دی استان اول در زمان ویرایش نال میداد)به جای استفاده از  کال بک ازین متغیر استفاده شده
   
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    
  };

  handleSave = () => {
    if (this.props.match.params.userId) {
      if (this.state.tell == this.state.oldTell) {
        EditUser(this.props.match.params.userId, {
          nationCode: this.state.nationCode,
          name: this.state.name,
          family: this.state.family,
          tell: this.state.tell,
          // passWord: this.state.passWord,
          address: this.state.address,
          email: this.state.email,
          businessCode: this.state.businessCode,
          CityId: this.state.cityId,
          // provinceId: this.state.provinceId,
          userTypeId: this.state.userTypeId,
          permission: this.state.permission,
          notebookGift: null,
          adminDescription: null,

          agent: this.state.agent,
          // introducerCode: this.state.introducerCode,
          Id: this.props.match.params.userId,
        })
          .then((response) => {
            if (response.status !== 200) {
              toast.error("خطای ویرایش شدن کاربر");
            } else if (response.status === 200) {
              toast.success("کاربر با موفقیت ویرایش شد");
              this.props.history.push("/main/users");
            }
            return response.json();
          })
          .then((responseJson) => {
            if (responseJson.Message)
              this.setState({
                errorMessage: responseJson.Message,
                openSnackbar: true,
              });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        HasTell(this.state.tell)
          .then((response) => {
            this.setState({ loading: false });
            if (response.status !== 200) {
              toast.error("خطای چک کردن شماره تماس");
            } else if (response.status === 200) {
              return response.json();
            }
          })
          .then((responseJson) => {
            if (responseJson.has == false) {
              EditUser(this.props.match.params.userId, {
                nationCode: this.state.nationCode,
                name: this.state.name,
                family: this.state.family,
                tell: this.state.tell,
                // passWord: this.state.passWord,
                address: this.state.address,
                email: this.state.email,
                businessCode: this.state.businessCode,
                CityId: this.state.cityId,
                // provinceId: this.state.provinceId,
                userTypeId: this.state.userTypeId,
                permission: this.state.permission,
                notebookGift: null,
                adminDescription: null,

                agent: this.state.agent,
                // introducerCode: this.state.introducerCode,
                Id: this.props.match.params.userId,
              })
                .then((response) => {
                  if (response.status !== 200) {
                    toast.error("خطای ویرایش شدن کاربر");
                  } else if (response.status === 200) {
                    toast.success("کاربر با موفقیت ویرایش شد");
                    this.props.history.push("/main/users");
                  }
                  return response.json();
                })
                .then((responseJson) => {
                  if (responseJson.Message)
                    this.setState({
                      errorMessage: responseJson.Message,
                      openSnackbar: true,
                    });
                })
                .catch((error) => {
                  console.error(error);
                });
            } else if (responseJson.has == true) {
              toast.error("شماره تماس قبلا وارد شده است");
            }
          });
      }
    } else {
      HasTell(this.state.tell)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status !== 200) {
            toast.error("خطای چک کردن شماره تماس");
          } else if (response.status === 200) {
            return response.json();
          }
        })
        .then((responseJson) => {
          if (responseJson.has == false) {
            AddUser({
              nationCode: this.state.nationCode,
              name: this.state.name,
              family: this.state.family,
              tell: this.state.tell,
              passWord: this.state.passWord,
              address: this.state.address,
              email: this.state.email,
              businessCode: this.state.businessCode,
              cityId: this.state.cityId,
              // provinceId: this.state.provinceId,
              userTypeId: this.state.userTypeId,
              permission: this.state.permission,
              agent: this.state.agent,
              notebookGift: null,
              adminDescription: null,
              // introducerCode: this.state.introducerCode,
            })
              .then((response) => {
                if (response.status !== 200) {
                  toast.error("خطای اضافه کردن کاربر");
                } else if (response.status === 200) {
                  toast.success("کاربر با موفقیت اضافه شد");

                  this.props.history.push("/main/users");
                }
                return response.json();
              })
              .then((responseJson) => {
                if (responseJson.Message)
                  this.setState({
                    errorMessage: responseJson.Message,
                    openSnackbar: true,
                  });
              })
              .catch((error) => {
                console.error(error);
              });
          } else if (responseJson.has == true) {
            toast.error("شماره تماس قبلا وارد شده است");
          }
        });
    }
  };

  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }

        break;
      case "family":
        this.setState({ family: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ familyHelper: "لطفا نام خانوادگی را وارد کنید" });
        } else {
          this.setState({ familyHelper: "" });
        }

        break;
      case "tell":
        this.setState({ tell: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({ tellHelper: "لطفا شماره تماس را عدد وارد کنید" });
        } else {
          this.setState({ tellHelper: "" });
        }

        break;

        break;

      case "passWord":
        this.setState({ passWord: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            passwordHelper: "لطفا رمزعبور  را وارد کنید",
          });
        } else {
          this.setState({ passwordHelper: "" });
        }

        break;
      case "address":
        this.setState({ address: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ addressHelper: "لطفا آدرس  را وارد کنید" });
        } else {
          this.setState({ addressHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.userId ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش کاربر
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن کاربر جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id="name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin="normal"
                      InputLabelProps={
                        this.state.name && this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name && this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.family && this.state.family.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.family && this.state.family.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.familyHelper.length !== 0}
                      helperText={this.state.familyHelper}
                      onChange={this.onchange}
                      id="family"
                      label="نام خانوادگی"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.family}
                      onChange={this.handleChange("family")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.tell && this.state.tell.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.tell && this.state.tell.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.tellHelper.length !== 0}
                      helperText={this.state.tellHelper}
                      onChange={this.onchange}
                      id="tell"
                      label="تلفن تماس"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.tell}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.passWord && this.state.passWord.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.passWord && this.state.passWord.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      disabled={this.props.match.params.userId}
                      error={this.state.passwordHelper.length !== 0}
                      helperText={this.state.passwordHelper}
                      onChange={this.onchange}
                      id="passWord"
                      type="password"
                      label="رمز عبور"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.passWord}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.address && this.state.address.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.address && this.state.address.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.addressHelper.length !== 0}
                      helperText={this.state.addressHelper}
                      onChange={this.onchange}
                      id="address"
                      label="آدرس"
                      multiline
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.address}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      id="standard-email"
                      label="رایانامه"
                      fullWidth
                      className={classes.textField}
                      value={this.state.email}
                      onChange={this.handleChange("email")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      id="standard-business-code"
                      label="کد صنفی"
                      fullWidth
                      className={classes.textField}
                      value={this.state.businessCode}
                      onChange={this.handleChange("businessCode")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      id="nationCode"
                      label="کد ملی"
                      fullWidth
                      className={classes.textField}
                      value={this.state.nationCode}
                      onChange={this.handleChange("nationCode")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.userTypeId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.userTypeId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="standard-select-user-type"
                      select
                      fullWidth
                      required
                      label="نوع کاربر"
                      className={classes.textField}
                      value={this.state.userTypeId}
                      onChange={this.handleChange("userTypeId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.userTypes.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="provinceId"
                      select
                      label="استان"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId && this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.province &&
                        this.state.province.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name} - {option.province}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="cityId"
                      select
                      label="شهر"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.cities &&
                        this.state.cities.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name} - {option.province}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.permission}
                        onChange={this.handleCheckChange("permission")}
                        value="permission"
                        color="primary"
                      />
                    }
                    label="سطح دسترسی"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agent}
                        onChange={this.handleCheckChange("agent")}
                        value="agent"
                        color="primary"
                      />
                    }
                    label="نماینده"
                  />
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        (this.state.name && this.state.name.length === 0) ||
                        this.state.familyHelper.length !== 0 ||
                        (this.state.family && this.state.family.length === 0) ||
                        this.state.tellHelper.length !== 0 ||
                        (this.state.tell && this.state.tell.length === 0) ||
                        this.state.passwordHelper.length !== 0 ||
                        (this.state.passWord &&
                          this.state.passWord.length === 0) ||
                        this.state.addressHelper.length !== 0 ||
                        (this.state.address &&
                          this.state.address.length === 0) ||
                        this.state.provinceId === null ||
                        this.state.cityId === null ||
                        this.state.userTypeId === null
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
